import Moment from 'moment';

export const timeRegIsInConflict = (timeReg, period) => {
	const timeRegDate = Moment(timeReg.updatedAt);
	const lockedDate = Moment(period.periodLockedTime);
	return period.periodLocked && !timeReg.retainerConflictHandled && timeRegDate.isAfter(lockedDate);
};
